import React, { useState, useEffect, useRef  } from 'react';
import axios from 'axios';

const Wishlist = () => {
    const [items, setItems] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const itemsRef = useRef(items);

    useEffect(() => {
        fetchWishlist();
        
        const handleAddToWishlist = (event) => {
            const fabricId = event.detail.fabricId;
            toggleWishlist(fabricId);
        };
        window.addEventListener('addToWishlist', handleAddToWishlist);
        return () => {
            window.removeEventListener('addToWishlist', handleAddToWishlist);
        };
    }, []);

    useEffect(() => {
        itemsRef.current = items;
        console.log('wishlist items', items)
    }, [items]);

    const toUrlFormat = (string) => string.replace(/ /g, '-')

    // get
    const fetchWishlist = async () => {
        try {
            const response = await axios.get('/api/wishlist');
            console.log(response)
            setItems(response.data);
            checkIfAddedToWishlist(response.data);
        } catch (error) {
            console.error('Error loading wishlist:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // post
    const addToWishlist = (fabricId) => {
        axios.post(`/api/wishlist/${fabricId}`)
            .then(() => {
                showNotification("Add to Wishlist");
                fetchWishlist();
                const wishlistButton = document.querySelector('.add-to-wishlist');
                if (wishlistButton) {
                    wishlistButton.classList.add('active');
                }
            })
            .catch(error => console.error('Error adding to wishlist:', error));
    };

    // delete
    const removeFromWishlist = (fabricId) => {
        axios.delete(`/api/wishlist/${fabricId}`)
            .then(() => {
                showNotification("Removed from Wishlist");
                fetchWishlist();
                const wishlistButton = document.querySelector('.add-to-wishlist');
                if (wishlistButton) {
                    wishlistButton.classList.remove('active');
                }
            })
            .catch(error => {
                console.error('Error removing from wishlist:', error);
            });
    };

    const toggleWishlist = (fabricId) => {
        const fabricExists = itemsRef.current.some(item => item.pkFabricID == fabricId);
        if (fabricExists) {
            removeFromWishlist(fabricId);
        } else {
            addToWishlist(fabricId);
        }
    };

    const checkIfAddedToWishlist = (items) => {
        const wishlistButton = document.querySelector('.add-to-wishlist');
        const fabricId = wishlistButton ? wishlistButton.getAttribute('data-fabric-id') : null;
        if (fabricId && items.some(item => item.pkFabricID == fabricId)) {
            wishlistButton.classList.add('active');
        }
    };

    // close wishlist
    const hideOverlay = () => {
        const overlay = document.getElementById('wishlist-overlay');
        if (overlay) {
            overlay.classList.remove('show');
            document.body.classList.remove('no-scroll');
        }
        const mobileWishlistBtn = document.getElementById('mobileWishlistBtn');
        mobileWishlistBtn.classList.remove('active');
    };

    // notification
    const showNotification = (message) => {
        const notificationHtml = `
            <div class="notification">
                <img src="/images/common/ok_circle.png" alt="success" class="max-width-18"> ${message}
            </div>`;

        const notificationContainer = document.getElementById('notification');
        if (notificationContainer) {
            notificationContainer.insertAdjacentHTML('beforeend', notificationHtml);

            setTimeout(() => {
                notificationContainer.innerHTML = '';
            }, 3000);
        }

        const notificationContainerMobile = document.getElementById('mobile-notification-container');
        if (notificationContainerMobile) {
            notificationContainerMobile.insertAdjacentHTML('beforeend', notificationHtml);

            setTimeout(() => {
                notificationContainerMobile.innerHTML = '';
            }, 3000);
        }
    };

    // order sample
    const orderSample = async (fabricId) => {
        const response = await axios.post('/api/shopping-cart/sample', JSON.stringify({ fabricId: fabricId }), { headers: { "Content-Type": "application/json" } })
        if (response.status === 200) {
            await fetchWishlist()
            await updateBasket()
        }
    }

    return (
        <div className='hide mobile-menu' id="wishlist-overlay">
            <div className="overlay-with-box headings-overlay active-group">
                <div className="overlay-box active-group flex-column pb-70 fit-content mobile-menu-container sm-px-12">
                    <div className='width-600 sm-max-w-100'>
                        {/* Row title */}
                        <div className="row">
                            <div className="col">
                                <h3 className='sm-h4'>My Wishlist</h3>
                            </div>
                            <div className="col-auto">
                                <span className="curtains-icon curtains-icon-close size-24 pointer" onClick={hideOverlay}></span>
                            </div>
                        </div>

                        {!isAuthenticated && (
                            <div className="max-width-310 body-text3 dark-text mt-16">
                                Wishlist is not saved permanently yet. <br />
                                Please <a className="underline" href="/login">Log in</a> or{' '}
                                <a className="underline" href="/sign-up">Create Account</a> to save it.
                            </div>
                        )}

                        <div className="accent-line mt-16"></div>

                        {/* Items */}
                        <div className="mt-54 sm-mt-32">
                            {items.length > 0 ? (
                                items.map(item => (
                                    <div className='mb-32 sm-mb-36' key={`${item.pkFabricID} ${item.fabricFullName}`}>
                                        <div className="row gap-24 sm-gap-16">
                                            <div className="col-auto">
                                                <img src={item.imageFilePathName} className="w-h-164 sm-mb-12" alt={`${item.fabricFullName}`} />
                                            </div>
                                            <div className="col flex-column min-height-164 sm-min-height-auto">
                                                <div className="row mb-8">
                                                    <div className="col">
                                                        <div className="subtitle1">{item.fabricFullName}</div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <span className="curtains-icon curtains-icon-octicon_trash-24 size-24 gray pointer sm-ms-12"
                                                            onClick={() => {
                                                                if (confirm('Are you sure you want to remove this item from your wishlist?')) {
                                                                    removeFromWishlist(item.pkFabricID)}
                                                                }
                                                            }
                                                        ></span>
                                                    </div>
                                                </div>

                                                <div className="body-text3">
                                                    <div className="mb_5 sm-text-14 sm-mb-8">
                                                        <span className="gray">Collection:</span>{' '}
                                                        <a href={`/brands/${toUrlFormat(item.fabricSupplierName)}/${item.pkFabricCollectionID}/${toUrlFormat(item.fabricCollectionName)}`} className="underline">
                                                            {item.fabricCollectionName}
                                                        </a>
                                                    </div>
                                                    <div className='mb-20 sm-mb-12 sm-text-15'>
                                                        £{item.displayPrice} <span className="gray">(per metre)</span>
                                                    </div>
                                                </div>

                                                <div className='sm-no'>
                                                    <div className="body-text3 color-bg2 to-bottom d-flex gap-2">
                                                        <div className={item.supplySamples? "width-180" : "width-145"}>
                                                            <a href={`/fabric/${item.pkFabricID}/${toUrlFormat(item.fabricName)}-${toUrlFormat(item.fabricColour)}`}>
                                                                <button className="d-flex btn justify-content-center align-items-center btn-100 btn-primary gap-2 btn-primary-dark" type="button">
                                                                    <span className="icon-container">
                                                                        <svg className="btn-star-1" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M6.5 13L5.90225 11.3846C5.16734 9.39854 3.60146 7.83266 1.6154 7.09775L5.68248e-07 6.5L1.6154 5.90225C3.60146 5.16734 5.16734 3.60146 5.90225 1.6154L6.5 -5.68248e-07L7.09775 1.6154C7.83266 3.60146 9.39854 5.16734 11.3846 5.90225L13 6.5L11.3846 7.09775C9.39854 7.83266 7.83266 9.39854 7.09775 11.3846L6.5 13Z"></path>
                                                                        </svg>

                                                                        <svg className="btn-star-2" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M4.5 9L4.08617 7.88164C3.57739 6.50668 2.49332 5.42261 1.11836 4.91383L3.93402e-07 4.5L1.11836 4.08617C2.49332 3.57739 3.57739 2.49332 4.08617 1.11835L4.5 -3.93402e-07L4.91383 1.11835C5.42261 2.49332 6.50668 3.57739 7.88165 4.08617L9 4.5L7.88165 4.91383C6.50668 5.42261 5.42261 6.50668 4.91383 7.88164L4.5 9Z"></path>
                                                                        </svg>

                                                                        <svg className="btn-star-3" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M3.5 7L3.17813 6.13017C2.78241 5.06075 1.93925 4.21759 0.869831 3.82187L3.0598e-07 3.5L0.869831 3.17813C1.93925 2.78241 2.78241 1.93925 3.17813 0.869831L3.5 -3.0598e-07L3.82187 0.869831C4.21759 1.93925 5.06075 2.78241 6.13017 3.17813L7 3.5L6.13017 3.82187C5.06075 4.21759 4.21759 5.06075 3.82187 6.13017L3.5 7Z"></path>
                                                                        </svg>
                                                                    </span>
                                                                    <span>View</span>
                                                                </button>
                                                            </a>
                                                        </div>
                                                        {
                                                            item.supplySamples === false ?
                                                                <button type='button' className='d-flex btn justify-content-center align-items-center btn-secondary gap-2 btn-primary-dark disabled'>
                                                                    <span>Samples unavailable</span>
                                                                </button>
                                                                :
                                                                <button type='button' className='d-flex btn justify-content-center align-items-center btn-secondary gap-2 btn-primary-dark' onClick={async () => await orderSample(item.pkFabricID)} disabled={item.inShoppingCart}>
                                                                    <span>{item.inShoppingCart ? 'Added to Basket' : 'order sample'}</span>
                                                                </button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sm-yes sm-column sm-gap-12">
                                            <a href={`/fabric/${item.pkFabricID}/${toUrlFormat(item.fabricName)}-${toUrlFormat(item.fabricColour)}`}>
                                                <button className="d-flex btn justify-content-center align-items-center btn-100 btn-primary gap-2 btn-primary-dark w-100 sm-ptb-12" type="button">
                                                    <span className="icon-container">
                                                        <svg className="btn-star-1" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M6.5 13L5.90225 11.3846C5.16734 9.39854 3.60146 7.83266 1.6154 7.09775L5.68248e-07 6.5L1.6154 5.90225C3.60146 5.16734 5.16734 3.60146 5.90225 1.6154L6.5 -5.68248e-07L7.09775 1.6154C7.83266 3.60146 9.39854 5.16734 11.3846 5.90225L13 6.5L11.3846 7.09775C9.39854 7.83266 7.83266 9.39854 7.09775 11.3846L6.5 13Z"></path>
                                                        </svg>

                                                        <svg className="btn-star-2" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M4.5 9L4.08617 7.88164C3.57739 6.50668 2.49332 5.42261 1.11836 4.91383L3.93402e-07 4.5L1.11836 4.08617C2.49332 3.57739 3.57739 2.49332 4.08617 1.11835L4.5 -3.93402e-07L4.91383 1.11835C5.42261 2.49332 6.50668 3.57739 7.88165 4.08617L9 4.5L7.88165 4.91383C6.50668 5.42261 5.42261 6.50668 4.91383 7.88164L4.5 9Z"></path>
                                                        </svg>

                                                        <svg className="btn-star-3" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M3.5 7L3.17813 6.13017C2.78241 5.06075 1.93925 4.21759 0.869831 3.82187L3.0598e-07 3.5L0.869831 3.17813C1.93925 2.78241 2.78241 1.93925 3.17813 0.869831L3.5 -3.0598e-07L3.82187 0.869831C4.21759 1.93925 5.06075 2.78241 6.13017 3.17813L7 3.5L6.13017 3.82187C5.06075 4.21759 4.21759 5.06075 3.82187 6.13017L3.5 7Z"></path>
                                                        </svg>
                                                    </span>
                                                    <span>View</span>
                                                </button>
                                            </a>
                                            {
                                                item.supplySamples ?
                                                    <></> :
                                                    <button type='button' className='d-flex btn justify-content-center align-items-center btn-secondary gap-2 btn-primary-dark w-100 sm-ptb-12' onClick={async () => await orderSample(item.pkFabricID)} disabled={item.inShoppingCart}>
                                                        <span>{item.inShoppingCart ? 'Added to Basket' : 'order sample'}</span>
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="ptb-80 px-170 border-bg5 sm-mt-32">
                                    <div className="text-center main">
                                        <span className="curtains-icon curtains-icon-fav size-58"></span>
                                    </div>
                                    <div className="content-center">
                                        <div className="text-center body-text3 mt-24 max-width-220">
                                            {isLoading? 
                                            (
                                                <span>Loading...</span>
                                            )
                                            :
                                            (
                                                <span>You have no items in your Wishlist.</span>
                                            )}
                                            
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Wishlist;
